class ImageModel {
  constructor({ id = "", imageUrl = "", imageName = "", createdDate = Date.now(), isBlur = false }) {
    this._id = id;
    this._imageUrl = imageUrl;
    this._imageName = imageName;
    this._createdDate = createdDate;
    this._isBlur = isBlur;
  }

  get id() {
    return this._id;
  }

  get imageUrl() {
    return this._imageUrl;
  }

  get imageName() {
    return this._imageName;
  }

  get createdDate() {
    return this._createdDate;
  }

  get isBlur() {
    return this._isBlur;
  }

  toJSON() {
    return {
      id: this._id,
      imageUrl: this._imageUrl,
      imageName: this._imageName,
      createdDate: this._createdDate,
      isBlur: this._isBlur,
    };
  }
}

export default ImageModel;
